import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import Hero from '../components/Hero';
import contactData from '../data/contact.json';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <div className="contact-page">
      <Hero
        heading={contactData.hero.heading}
        backgroundImage={contactData.hero.backgroundImage}
        compact
      />

      <section className="section">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info-section">
              <div className="orange-divider" />
              <h2 className="section-heading">{contactData.getInTouch.heading}</h2>
              <p className="contact-description">{contactData.getInTouch.description}</p>

              <div className="contact-details">
                <div className="contact-detail-item">
                  <div className="contact-detail-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div>
                    <h4>{contactData.getInTouch.address.label}</h4>
                    <p>{contactData.getInTouch.address.value}</p>
                  </div>
                </div>

                <div className="contact-detail-item">
                  <div className="contact-detail-icon">
                    <FaPhone />
                  </div>
                  <div>
                    <h4>{contactData.getInTouch.phone.label}</h4>
                    <a href={`tel:${contactData.getInTouch.phone.value}`}>
                      {contactData.getInTouch.phone.value}
                    </a>
                  </div>
                </div>

                <div className="contact-detail-item">
                  <div className="contact-detail-icon">
                    <FaEnvelope />
                  </div>
                  <div>
                    <h4>{contactData.getInTouch.email.label}</h4>
                    <a href={`mailto:${contactData.getInTouch.email.value}`}>
                      {contactData.getInTouch.email.value}
                    </a>
                  </div>
                </div>

                <div className="contact-detail-item">
                  <div className="contact-detail-icon">
                    <FaLinkedin />
                  </div>
                  <div>
                    <h4>Follow Us</h4>
                    <a
                      href={contactData.getInTouch.social[0].url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form-section">
              <h3 className="form-heading">Send Us a Message</h3>
              <form
                className="contact-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.target as HTMLFormElement;
                  const name = (form.elements.namedItem('name') as HTMLInputElement).value;
                  const email = (form.elements.namedItem('email') as HTMLInputElement).value;
                  const subject = (form.elements.namedItem('subject') as HTMLInputElement).value;
                  const message = (form.elements.namedItem('message') as HTMLTextAreaElement).value;
                  const mailtoLink = `mailto:${contactData.getInTouch.email.value}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\n${message}`)}`;
                  window.location.href = mailtoLink;
                }}
              >
                <div className="form-row">
                  <div className="form-group">
                    <input type="text" name="name" placeholder="Your Name" required />
                  </div>
                  <div className="form-group">
                    <input type="email" name="email" placeholder="Your Email" required />
                  </div>
                </div>
                <div className="form-group">
                  <input type="text" name="subject" placeholder="Subject" required />
                </div>
                <div className="form-group">
                  <textarea name="message" rows={5} placeholder="Your Message" required />
                </div>
                <button type="submit" className="btn btn-primary form-submit">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
